import { numericExtent, wmaSeries } from "../utils";
const WMA = {
    name: "WMA",
    compute: (bars, period = 9) => wmaSeries(bars.map((b) => b.close), period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default WMA;
